import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalHistory extends BaseModelAPI {
	static entity = 'approvalhistory';
	static entityName = 'approvalhistory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.approvalInstanceId = '';
			this.approvalInstance = {};
			this.approverTypeId = '';
			this.approverType = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.approverLevel = 0;
			this.approverUserName = '';
			this.sequence = 0;
			this.acitivtyStateId = '';
			this.acitivtyState = {};
			this.approvalConfigurationInstanceDetailId = '';
			this.approvalConfigurationInstanceDetail = {};
			this.message = '';
			this.updatedDate = '';
			this.status = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}